import { render, staticRenderFns } from "./PopupAdd.vue?vue&type=template&id=f6b6be20&scoped=true"
import script from "./PopupAdd.vue?vue&type=script&lang=js"
export * from "./PopupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b6be20",
  null
  
)

export default component.exports